export default ['JsonRPCService', 'JobService', function (JsonRPCService, JobService) {
    return {
        createSubmission: function createSubmission(newSubmission) {
            return JsonRPCService.send('pc', 'gateway/submission', 'createNewSubmission', [newSubmission]);
        },
        findJobByJobNumber: function findJobByJobNumber(submissionNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'findJobByJobNumber', [submissionNumber]);
        },
        getSubmissionSummary: function getSubmissionSummary(submissionNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'getSubmissionSummary', [submissionNumber]);
        },
        getNotesForSubmission: function getNotesForSubmission(submissionNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'getNotesForSubmission', [submissionNumber]);
        },
        createNoteForSubmission: function createNoteForSubmission(submissionNumber, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/submission', 'createNoteForSubmission', [submissionNumber, noteDTO]);
        },
        getDocumentsForSubmission: function getDocumentsForSubmission(submissionNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'getDocumentsForSubmission', [submissionNumber]);
        },
        getUWIssuesForSubmission: function getUWIssuesForSubmission(submissionNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'getUWIssuesForSubmission', [submissionNumber]);
        },
        referToUnderwriter: function referToUnderwriter(submissionNumber, noteBody) {
            return JsonRPCService.send('pc', 'gateway/submission', 'referToUnderwriter', [submissionNumber, noteBody]);
        },
        withdrawSubmissionBySubmissionNumber: function withdrawSubmissionBySubmissionNumber(submissionNumber) {
            return JobService.withdrawJobByJobNumber(submissionNumber);
        },
        getPerCapitaCodes: function getPerCapitaCodes() {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'getPerCapitaCodes');
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/SubmissionService.js
// module id = 1796
// module chunks = 0